import {
  TestStatus,
  TestStatusAccepted,
  TestStatusCategory,
  TestStatusForced,
  TestStatusRejected,
  TestStatusWaiting,
} from './serializedTagTypes';
/* eslint no-bitwise: 0 */
export function toIP(value: string): string {
  if (!value) return '';
  const result = /\d+/.exec(value);

  if (!result) {
    throw new Error('E_INTEGER_NOT_FOUND');
  }

  const intvalue = parseInt(result[0], 10);

  return [(intvalue >> 24) & 0xff, (intvalue >> 16) & 0xff, (intvalue >> 8) & 0xff, intvalue & 0xff].join('.');
}

const isInEnumValues = (value: TestStatus, enumObject: { [s: string]: TestStatus }) =>
  Object.values(enumObject).includes(value);

export const isStatusAccepted = (status: TestStatus) => isInEnumValues(status, TestStatusAccepted);
export const isStatusAcceptedOrForced = (status: TestStatus) =>
  status === TestStatusForced.forceAccepted || isStatusAccepted(status);
export const isStatusWaiting = (status: TestStatus) => isInEnumValues(status, TestStatusWaiting);
export const isStatusRejected = (status: TestStatus) => !status || isInEnumValues(status, TestStatusRejected);
export const isStatusRejectedOrForced = (status: TestStatus) =>
  status === TestStatusForced.forceRejected || isStatusRejected(status);
export const isStatusForced = (status: TestStatus) => isInEnumValues(status, TestStatusForced);

export const getTestStatusCategory = (status: TestStatus) =>
  isStatusAccepted(status)
    ? TestStatusCategory.accepted
    : isStatusWaiting(status)
      ? TestStatusCategory.waiting
      : isStatusForced(status)
        ? TestStatusCategory.forced
        : TestStatusCategory.rejected;
